module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Light.d3d624c0.woff2";